import { OrganizationRole, User } from '../services';

const SUPERADMIN_ROLES: ReadonlyArray<string> = ['superadmin'];
const ADMIN_LIKE_ROLES: ReadonlyArray<OrganizationRole> = ['owner', 'admin'];

const hasSuperadminRole = (user: Pick<User, 'roles'> | null | undefined): boolean => {
  if (!user?.roles || !Array.isArray(user.roles)) {
    return false;
  }
  return user.roles.some(role => SUPERADMIN_ROLES.includes(role));
};

/**
 * Verifica se o usuario pode administrar a organizacao atual.
 *
 * Considera (nesta ordem):
 *  1. role de membership na organizacao atual ('owner' ou 'admin')
 *  2. role global 'superadmin' como override de plataforma
 */
export const isOrganizationAdmin = (
  user: Pick<User, 'organization_role' | 'roles'> | null | undefined
): boolean => {
  if (!user) return false;
  if (user.organization_role && ADMIN_LIKE_ROLES.includes(user.organization_role)) {
    return true;
  }
  return hasSuperadminRole(user);
};

/**
 * Verifica se o usuario e dono da organizacao atual.
 *
 * Considera:
 *  1. role de membership 'owner'
 *  2. 'superadmin' global como override
 */
export const isOrganizationOwner = (
  user: Pick<User, 'organization_role' | 'roles'> | null | undefined
): boolean => {
  if (!user) return false;
  if (user.organization_role === 'owner') {
    return true;
  }
  return hasSuperadminRole(user);
};
